module.exports = __webpack_public_path__ + "static/media/emerson.99b48461.png";